import { JssConfig } from 'lib/config';
import { loadEdgeRuntimeConfig } from './loadEdgeRuntimeConfig';

export const loadRuntimeConfig = (): JssConfig => {
  const nodeRequire = require as NodeRequire;
  try {
    const resolvedPath = nodeRequire.resolve('../../temp/config.js');

    delete nodeRequire.cache[resolvedPath];

    const runtimeConfig = nodeRequire('../../temp/config.js');

    return runtimeConfig?.default ?? runtimeConfig;
  } catch (error) {
    if ((error as NodeJS.ErrnoException).code !== 'MODULE_NOT_FOUND') {
      throw error;
    }

    return loadEdgeRuntimeConfig();
  }
};
